import { EditableHandle } from './Editable';
import { ReadOnlyHandle } from './ReadOnly';
import { type NodeHandleProps } from './constants';
import { useReactFlowViewContext } from '../../../../context/context';

export function NodeHandle(props: NodeHandleProps) {
  const { isEditable } = useReactFlowViewContext();

  return isEditable ? <EditableHandle {...props} /> : <ReadOnlyHandle {...props} />;
}
